import { render } from "./CardText.vue?vue&type=template&id=74e8fbc1"
import script from "./CardText.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CardText.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__